const buildStat = (
  displayName: string,
  path: string,
  link: string[] | null = [],
  useCurrencyPipe = false
) => {
  return { displayName, path, link, useCurrencyPipe };
};

interface datasource {
  url: string;
  method: 'GET' | 'POST';
  payload: any;
  authorized: boolean;
}

export interface DashboardTile {
  type: 'custom' | 'builtin';
  title: string;
  link: string | null;
  bigFigurePath: string | null;
  bigFigureValue?: number | string | null;
  useCurrencyPipe: boolean;
  dataSource?: datasource;
  stats: {
    displayName: string;
    path: string;
    link: string[] | null;
    useCurrencyPipe: boolean;
    dataSource?: datasource;
  }[];
}

export const dashboardStatsCards: DashboardTile[] = [
  {
    type: 'builtin',
    title: 'Active Hires',
    link: 'active',
    bigFigurePath: 'active.total',
    useCurrencyPipe: false,
    bigFigureValue: null,
    stats: [
      buildStat('Items', 'active.items'),
      buildStat('Returning today', 'active.dueBackToday', ['active', 'today']),
      buildStat('Overdue', 'active.overdue', ['active', 'overdue']),
      buildStat('Unknown return', 'active.unknown', ['active', 'unknown'])
    ]
  },
  {
    type: 'builtin',
    title: 'Pending payment',
    link: 'pending',
    bigFigurePath: 'pending.totals.count',
    useCurrencyPipe: false,
    stats: [
      buildStat(
        'Total value',
        'pending.totals.balance',
        ['pending', 'all'],
        true
      ),
      buildStat(
        'Hires',
        'pending.docket.balance',
        ['pending', 'dockets'],
        true
      ),
      buildStat('Sales', 'pending.sale.balance', ['pending', 'sales'], true),
      buildStat(
        'Repairs',
        'pending.repair.balance',
        ['pending', 'repairs'],
        true
      ),
      buildStat(
        'Overpaid Hires',
        'pending.overpaid.balance',
        ['pending', 'overpaid'],
        true
      )
    ]
  },
  {
    type: 'builtin',
    title: 'Open Bookings',
    link: 'bookings',
    bigFigureValue: null,
    useCurrencyPipe: false,
    bigFigurePath: 'bookings.total',
    stats: [
      buildStat('Overdue', 'bookings.overdue', ['bookings', 'overdue']),
      buildStat('Today', 'bookings.today', ['bookings', 'today']),
      buildStat('This week', 'bookings.thisWeek', ['bookings', 'week']),
      buildStat('Requests', 'bookings.request', ['bookings', 'request']),
      buildStat('Awaiting customer response', 'bookings.awaitingResponse', [
        'bookings',
        'awaiting'
      ]),
      buildStat('Confirmed', 'bookings.confirmed', ['bookings', 'confirmed']),
      buildStat('Stock Warnings', 'bookings.stockWarnings', [
        'bookings',
        'stockWarnings'
      ])
    ]
  },
  {
    type: 'builtin',
    title: 'Transport Jobs',
    bigFigureValue: null,
    link: 'deliveries',
    useCurrencyPipe: false,
    bigFigurePath: 'deliveries.total',
    stats: [
      buildStat('Overdue', 'deliveries.overdue', ['deliveries', 'overdue']),
      buildStat('Today', 'deliveries.today', ['deliveries', 'today']),
      buildStat('This Week', 'deliveries.thisWeek', ['deliveries', 'week'])
    ]
  },
  {
    type: 'builtin',
    title: 'Workshop',
    bigFigureValue: null,
    link: 'workshop',
    bigFigurePath: 'workshop.total',
    useCurrencyPipe: false,
    stats: [
      buildStat('Booked in', 'workshop.booked_in', ['workshop', 'booked_in']),
      buildStat('Assessed', 'workshop.assessed', ['workshop', 'assessed']),
      buildStat('Quotation', 'workshop.quotation', ['workshop', 'quotation']),
      buildStat('Quote accepted', 'workshop.quote_approved', [
        'workshop',
        'quote_approved'
      ]),
      buildStat('Waiting for parts', 'workshop.waiting_for_parts', [
        'workshop',
        'waiting_for_parts'
      ]),
      buildStat('Repair started', 'workshop.repair_started', [
        'workshop',
        'repair_started'
      ])
    ]
  },
  {
    type: 'builtin',
    title: 'My Jobs',
    link: 'my-jobs',
    bigFigureValue: null,
    bigFigurePath: null,
    useCurrencyPipe: false,
    stats: []
  }
];
